import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeDebtors = async ({
    token,
    charge_id
}) => {

    const params = {
        charge_id
    }

    try {
        const res = await axiosCreate.get('/charge/debtor', {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}